import { css } from '@emotion/react';
import { type MemoExoticComponent, memo, type ReactNode } from 'react';

import { McqTableOfContentsItem } from './item/McqTableOfContentsItem';

export type McqTableOfContentsProps = {
  /** `McqTableOfContents.Item` components. */
  children?: ReactNode;
};

export const McqTableOfContentsBase = ({ children = null }: McqTableOfContentsProps) => (
  <ul
    css={css`
      list-style: none;
    `}
  >
    {children}
  </ul>
);

McqTableOfContentsBase.displayName = 'McqTableOfContents';

export const McqTableOfContents: MemoExoticComponent<typeof McqTableOfContentsBase> & {
  Item?: typeof McqTableOfContentsItem;
} = memo(McqTableOfContentsBase);

McqTableOfContents.Item = McqTableOfContentsItem;
